import './hero.css';

export default (element, data) => {};